import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_BetModal = _resolveComponent("BetModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      onOnClick: _ctx.toggleBetModal,
      color: _ctx.color,
      text: "Vote"
    }, null, 8, ["onOnClick", "color"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showBetModal)
          ? (_openBlock(), _createBlock(_component_BetModal, {
              key: 0,
              teamName: _ctx.teamName,
              teamColor: _ctx.color,
              dapp: _ctx.dapp,
              onToggleBetModal: _ctx.toggleBetModal
            }, null, 8, ["teamName", "teamColor", "dapp", "onToggleBetModal"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}